import { NavLink } from 'react-router-dom';
import './Header.css';

export default function Header({ open, onClose }) {
  return (
    <header className="header">
      <div className="header-top">
        <div className="header-left">
          <div className="logo">
            <img src={require('../img/site_logostreamerpanel.gif')} alt="Salerno Streamerpanel" className="logo-img" />
          </div>
          <div className="header-title">
            <h1>Salerno Streamerpanel</h1>
            <span className="header-subtitle">Dein Panel für Streamer !</span>
          </div>
        </div>
        <nav className="header-center">
          <NavLink to="/faq" className="header-nav-link">
            FAQ
          </NavLink>
          <NavLink to="/information" className="header-nav-link">
            Informationen
          </NavLink>
        </nav>
        <div className="header-right">
          <button className="menu-toggle" onClick={() => onClose(!open)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
